/**
 * References to the location of the banner and
 * the flag/experiment name for the banner in amplitude
 */
export const BANNER_SLOT_LOCATION = {
  ABOVE_ALL_BANNER_HOME_SCREEN: 'above_all_banner_home_screen',
  ABOVE_ALL_BANNER_PLACE_SCREEN: 'above_all_banner_place_screen',
  TOP_BANNER_HOME_WEB: 'top_banner_home_web',
  MIDDLE_BANNER_HOME: 'middle_banner_home',
  BOTTOM_BANNER_HOME: 'bottom_banner_home',
  TOP_BANNER_SEARCH: 'top_banner_search',
  MIDDLE_BANNER_SEARCH: 'middle_banner_search',
  MIDDLE_BANNER_SEARCH_WEB: 'middle_banner_search_web',
  MIDDLE_BANNER_BLOG: 'middle_banner_blog',
  TOP_BANNER_GIFTCARD_CHECKOUT: 'top_banner_giftcard_checkout',
} as const;

/**
 * Fixed height for the above all banner to be used in layout calculations
 */
export const ABOLVE_ALL_BANNER_HEIGHT = 75;
